import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import ActivationSteps from "../components/ActivationSteps";
import { Phone } from "lucide-react";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";
import FAQKookgroep from "../components/FAQkookgroep";

function KookgroepAansluiten() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Kookgroep aansluiten - Elektraaanleggen.nl"
        description="Laat uw kookgroep vakkundig aansluiten door onze gecertificeerde elektriciens. Veilig en volgens de laatste normen. Zorg voor een betrouwbare stroomvoorziening voor uw inductiekookplaat."
        schema={generateServiceSchema({
          name: "Kookgroep Aansluiten",
          description:
            "Onze gecertificeerde elektriciens zorgen voor het veilig aansluiten van uw kookgroep voor inductiekookplaten, volgens de laatste normen en regelgeving. Professionele installatie voor een betrouwbare stroomvoorziening.",
          image: "https://elektraaanleggen.nl/images/banner.png",
        })}
      />

      <Header />
      <HeroSection
        title="Kookgroep aansluiten"
        description="Laat uw kookgroep vakkundig aansluiten door onze gecertificeerde elektriciens. Veilig en volgens de laatste normen."
        imageSrc="/images/perilexaan.png"
      />

      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Professionele kookgroep installatie door experts
            </h2>
            <div className="mb-6">
              <p className="text-[#17354A] font-medium mb-4">
                Onze naam vertelt het al: Elektra Aanleggen, en dat is wat je
                doet om een kookgroep te realiseren: het aanbrengen van een
                5-aderige YMVK-kabel van de groepenkast tot de positie van de
                inductiekookplaat. Om elektrisch te kunnen koken op een
                inductie- of keramische kookplaat.
              </p>
              <br></br>
              <p className="text-[#17354A] font-medium mb-4">
                We zullen met u kijken welke kookplaat u heeft gekozen en welke
                perilex-aansluiting nodig is voor dit type. Niet alle
                aansluitingen zijn hetzelfde: een 2-fase kookgroep of 3-fase, en
                het kW-verbruik van de inductie is ook van belang. Het is
                belangrijk om te weten welke kookgroep of krachtgroep er nodig
                is, geen zorgen: bij Elektra Aanleggen zorgen wij voor de
                volledige voorbereiding en vakkundige installatie, zodat u
                nergens meer naar om hoeft te kijken.
              </p>
              <br></br>
              <p className="text-[#17354A] font-medium mb-4">
                Krijgt u een nieuwe keuken en worden de posities van uw
                apparaten gewijzigd? Geen zorgen! Bij Elektra Aanleggen zorgen
                wij ervoor dat alle elektrische aansluitingen correct worden
                verplaatst en aangepast volgens de keukentekening van de
                leverancier. Moet er gefreesd of een extra groep aangelegd
                worden? Wij regelen het vakkundig, zodat uw nieuwe keuken
                perfect functioneert.
              </p>
            </div>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>

              <img
                alt="Kookgroep installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/perilex-aansluiten-kookgroep-elektraaanleg.jpg"
              />
            </div>
          </div>
        </div>

        <ActivationSteps />

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Wat is een kookgroep en waarom heb je die nodig?
            </h2>
            <p className="text-[#17354A] font-medium mb-4">
              Steeds meer huishoudens stappen over op elektrisch koken, vooral
              met een inductiekookplaat. Dit is niet alleen energiezuiniger en
              sneller dan koken op gas, maar ook veiliger en gemakkelijker in
              onderhoud. Toch is het belangrijk om te weten dat een standaard
              stroomgroep in je meterkast vaak niet geschikt is om een
              inductiekookplaat van voldoende stroom te voorzien.
            </p>

            <p className="text-[#17354A] font-medium mb-4">
              Een inductiekookplaat verbruikt namelijk veel meer stroom dan
              andere keukenapparaten zoals een magnetron, oven of waterkoker.
              Zonder de juiste elektrische aansluiting kan dit leiden tot
              overbelasting van de groepenkast, waardoor de stoppen doorslaan of
              de kookplaat niet optimaal functioneert. In sommige gevallen kan
              een verkeerde aansluiting zelfs brandgevaar opleveren. Daarom is
              het essentieel om een speciale kookgroep te laten installeren,
              zodat de elektrische belasting goed wordt verdeeld en de
              stroomvoorziening veilig en efficiënt blijft.
            </p>

            <p className="text-[#17354A] font-medium mb-4">
              Bij Elektra Aanleggen helpen wij je graag met deskundig advies en
              een professionele installatie van jouw kookgroep. Wil je weten
              welke kookgroep het beste bij jouw situatie past? Neem dan
              vrijblijvend contact met ons op, wij staan klaar om je te
              adviseren!
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>

              <img
                alt="Slim stroom handelen met thuisbatterij"
                loading="lazy"
                width="1028"
                height="1032"
                decoding="async"
                data-nimg="1"
                src="/images/perilex-kookplaat.png"
                srcSet="/images/perilex-kookplaat.png"
                style={{ color: "transparent" }}
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Elektra bij het plaatsen van een nieuwe keuken
            </h2>
            <p className="text-[#17354A] font-medium mb-4">
              Heb je een nieuwe keuken gekocht? Dan is het belangrijk om de
              elektrische voorzieningen goed te regelen. De stroompunten en
              stopcontacten moeten precies op de juiste plekken zitten, zodat de
              keuken zonder problemen gemonteerd kan worden. Dit geldt voor de
              aansluiting van al je apparaten, zoals de oven, inductiekookplaat,
              vaatwasser en koelkast.
            </p>
            <p className="text-[#17354A] font-medium mb-4">
              Om de elektra perfect af te stemmen op jouw nieuwe keuken, hebben
              we een keukentekening nodig. Op basis hiervan kunnen we exact
              bepalen waar de aansluitingen en stroompunten moeten komen. Dit
              voorkomt last-minute aanpassingen en zorgt ervoor dat de
              installatie soepel verloopt.
            </p>

            <p className="text-[#17354A] font-medium mb-4">
              Bij Elektra Aanleggen kunnen we je vaak al een prijsindicatie
              geven voor de elektra-installatie van je nieuwe keuken of het
              aanleggen van een kookgroep, zodra je ons de keukentekening
              aanlevert. Dankzij onze jarenlange ervaring in het voorbereiden
              van elektra voor keukens, begeleiden we je van begin tot eind. Zo
              zorgen wij ervoor dat jouw keuken klaar is voor gebruik, en jij
              zorgeloos kunt genieten van je nieuwe kookruimte!
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>
              <img
                alt="Kookgroep installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/kitchen.avif"
              />
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />

      {/* <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>
              <img
                alt="Inductiekoken voordelen"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/1200x674.jpg"
              />
            </div>
          </div>
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Wat zijn de voordelen van inductiekoken?
            </h2>
            <p>
              Inductiekoken biedt tal van voordelen ten opzichte van
              traditionele kookmethodes. Het is energiezuiniger, sneller en
              veiliger. In tegenstelling tot gas- of elektrische kookplaten
              verhit inductie alleen de pan, waardoor er minder energie verloren
              gaat. Dit resulteert in lagere energiekosten. Bovendien is
              inductiekoken veiliger omdat de kookplaat zelf niet heet wordt,
              waardoor het risico op brand of verbranding vermindert.
            </p>
          </div>
        </div>
      </section> */}

      <FAQKookgroep />

      <ServiceHighlights />
      <Reviews />
      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#2FB6D2] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Gratis offerte
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default KookgroepAansluiten;
